var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTimelineNext = function SvgTimelineNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    x: 0.5,
    y: 0.5,
    stroke: "#D2D3DB",
    rx: 27.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1FB0F7",
    d: "m27.348 36.5-3.698 1.275a2 2 0 0 1-2.652-1.927l.071-3.91a2 2 0 0 0-.403-1.241l-2.356-3.122a2 2 0 0 1 1.013-3.118l3.741-1.14a2 2 0 0 0 1.056-.768l2.24-3.205a2 2 0 0 1 3.28 0l2.24 3.205a2 2 0 0 0 1.056.767l3.74 1.141a2 2 0 0 1 1.014 3.118l-2.356 3.122a2 2 0 0 0-.403 1.24l.07 3.911a2 2 0 0 1-2.651 1.927L28.652 36.5a2 2 0 0 0-1.304 0Z"
  }))));
};
export default SvgTimelineNext;